import { useEffect, useState } from 'react';
import {
	AI_SETTINGS_NAVIGATION,
	isAiSettingsSection,
	type AiSettingsSection,
} from '../ai-settings-navigation.js';

export function AiSettingsNavigation({
	activeSection,
	onNavigate,
}: {
	activeSection?: string;
	onNavigate: (section: AiSettingsSection) => void;
}) {
	const [open, setOpen] = useState(!!activeSection && isAiSettingsSection(activeSection));
	useEffect(() => {
		if (activeSection && isAiSettingsSection(activeSection)) setOpen(true);
	}, [activeSection]);
	return (
		<div>
			<button
				type="button"
				className="settings-menu-toggle"
				aria-expanded={open}
				onClick={() => setOpen((value) => !value)}
			>
				<span>AI</span>
				<svg aria-hidden="true" className="settings-menu-chevron" viewBox="0 0 20 20">
					<path d="m6 8 4 4 4-4" />
				</svg>
			</button>
			{open && (
				<div
					role="group"
					aria-label="AI settings navigation"
					className="settings-sidebar-subnav"
				>
					{AI_SETTINGS_NAVIGATION.map((item) => (
						<button
							type="button"
							key={item.section}
							aria-current={activeSection === item.section ? 'page' : undefined}
							className={activeSection === item.section ? 'active' : ''}
							onClick={() => onNavigate(item.section)}
						>
							{item.label}
						</button>
					))}
				</div>
			)}
		</div>
	);
}
